import type { FC, ReactNode } from "react";
import React from "react";
import { Box } from "@mui/material";

type Props = {
  children?: ReactNode;
};

const ScrollableCardContent: FC<Props> = ({ children, ...props }) => (
  <Box
    {...props}
    style={{
      height: "100%",
      overflowY: "auto",
    }}
    data-testid="ScrollableCardContent"
  >
    {children}
  </Box>
);

export default ScrollableCardContent;
